// extracted by mini-css-extract-plugin
export default {"HtmlWrapper":"BhnNZzjYs3XgWppMuT52","Html":"c6oa_7lCyEElglCnT0DZ","OverflowEllipsis":"f2ewsRO6OeiLeK2nOhNm"};